import request from "@/utils/request";
import { getSign, getStamp, getRandom } from "@/utils/util";

let BASE_URL = "";
if (window.location.href.indexOf("oa-test.songshuai.com") > -1) {
  BASE_URL = "//oa-api-test.songshuai.com/oa/";
} else if (window.location.href.indexOf("oa.songshuai.com") > -1) {
  BASE_URL = "//oa-api.songshuai.com/oa/";
} else if (window.location.href.indexOf("oa-pre.songshuai.com") > -1) {
  BASE_URL = "//oa-api-pre.songshuai.com/oa/";
} else if (window.location.href.indexOf('oa.fe.dev.myyixue.com') > -1) {
  BASE_URL = '//oa-api.zc.dev.myyixue.com/oa/';
} else {
  BASE_URL = "https://oa-api-test.songshuai.com/oa/";
}

// 第三方账号登录
export const loginByDD = (data) => {
  return request({
    baseURL: BASE_URL + "account/thirdpart/login",
    method: "post",
    data,
  });
};

export const loginByPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/accountCenter/login",
    method: "post",
    data,
  });
};

// 发送验证码
export const getVCode = (data) => {
  return request({
    baseURL: BASE_URL + "account/accountCenter/sendVCode",
    method: "post",
    data,
  });
};

// 验证验证码
export const checkVCode = (data) => {
  return request({
    baseURL: BASE_URL + "account/checkVCode",
    method: "post",
    data,
  });
};

// 验证手机号是否注册
export const checkPhoneReg = (data) => {
  return request({
    baseURL: BASE_URL + "account/checkPhoneReg",
    method: "post",
    data,
  });
};

// 退出登录
export const logout = (data) => {
  return request({
    baseURL: BASE_URL + "account/loginOut",
    method: "post",
    data,
  });
};

// 绑定手机
export const bindPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/bindPhone",
    method: "post",
    data,
  });
};

// 已绑松鼠系统列表
export const systemList = (data) => {
  return request({
    baseURL: BASE_URL + "songshusystem/systemList",
    method: "post",
    data,
  });
};

// 获取用户信息
export const getAccountByPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/getAccountByPhone",
    method: "post",
    data,
  });
};

// 申请验证旧手机号码 （向旧手机发送验证码）
export const applyCheckOldPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/applyCheckOldPhone",
    method: "post",
    data,
  });
};

// 验证旧手机号码
export const checkOldPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/checkOldPhone",
    method: "post",
    data,
  });
};

// 申请验证新手机号码
export const applyCheckNewPhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/applyCheckNewPhone",
    method: "post",
    data,
  });
};

// 更换手机号码
export const changePhone = (data) => {
  return request({
    baseURL: BASE_URL + "account/changePhone",
    method: "post",
    data,
  });
};

// 钉钉换绑
export const bindChange = (data) => {
  return request({
    baseURL: BASE_URL + "thirdpart/bind",
    method: "post",
    data,
  });
};

// 解绑手机号
export const unBindMobile = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/unBindMobile",
    method: "post",
    data,
  });
};

// 绑钉钉
export const unBindDing = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/unBindDing",
    method: "post",
    data,
  });
};

// 绑定手机号
export const bindMobile = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/bindMobile",
    method: "post",
    data,
  });
};

// 验证绑定手机号
export const checkBindMobile = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/checkBindMobile",
    method: "post",
    data,
  });
};

// 绑定钉钉
export const bindDing = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/bindDing",
    method: "post",
    data,
  });
};

// 验证绑定钉钉
export const checkBindDing = (data) => {
  return request({
    baseURL: BASE_URL + "accountBind/checkBindDing",
    method: "post",
    data,
  });
};

// 醒员工账号
export const wakeUpAccount = (data) => {
  return request({
    baseURL: BASE_URL + "account/wakeUpAccount",
    method: "post",
    data,
  });
};

// 禁用详情
export const getAccountDisableDetail = (data) => {
  return request({
    baseURL: BASE_URL + "account/getAccountDisableDetail",
    method: "post",
    data,
  });
};
// 冻结详情
export const getAccountFreezeDetail = (data) => {
  return request({
    baseURL: BASE_URL + "account/getAccountFreezeDetail",
    method: "post",
    data,
  });
};
// 检测是否唤醒员工账号
export const checkWakeUpAccount = (data) => {
  return request({
    baseURL: BASE_URL + "account/checkWakeUpAccount",
    method: "post",
    data,
  });
};
// 获取子账号列表
export const getAccountList = (data) => {
  return request({
    baseURL: BASE_URL + "account/getAccountList",
    method: "post",
    data,
  });
};

// 登录
export const dingdingLogin = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/login",
    method: "post",
    data,
  });
};

// 系统登出
export const loginOut = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/login/logout",
    method: "post",
    data,
  });
};

// 获取授权码
export const authorize = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/login/authorize",
    method: "post",
    data,
  });
};

// 授权码换取code
export const getLoginCode = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/login/token",
    method: "post",
    data,
  });
};

// 检查登录态
export const checkToken = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/login/checkToken",
    method: "post",
    data,
  });
};

// 刷新token
export const refreshToken = (data, config) => {
  return request({
    baseURL: BASE_URL + "api/staff/login/refreshToken",
    method: "post",
    data,
    ...config, // 透传配置参数
  });
};

// 获取用户信息
export const getUserInfo = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/user/getUserInfo",
    method: "get",
    data,
  });
};

// 获取我的应用列表
export const getMyAppList = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/user/getMyAppList",
    method: "post",
    data,
  });
};

// 获取推荐应用列表
export const getRecommendAppList = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/user/getRecommendAppList",
    method: "post",
    data,
  });
};

export const backendLogin = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/background/login",
    method: "post",
    data,
  });
};

export const modifyPassword = (data) => {
  return request({
    baseURL: BASE_URL + "api/staff/user/modifyPassword",
    method: "post",
    data,
  });
};

export const getTemporaryAuto = (data) => {
  return request({
    baseURL: BASE_URL + "api/staffInfo/getTemporaryAuto",
    method: "post",
    data,
  });
};

export function getAppList(data) {
  return request({
    baseURL: BASE_URL + "application/getAppList",
    method: "post",
    data,
  });
}

export function editApp(data) {
  return request({
    baseURL: BASE_URL + "application/editApp",
    method: "post",
    data,
  });
}

export function addApp(data) {
  return request({
    baseURL: BASE_URL + "application/addApp",
    method: "post",
    data,
  });
}

export function getAppConfig(data) {
  return request({
    baseURL: BASE_URL + "application/getAppConfig",
    method: "post",
    data,
  });
}

export function editAppConfig(data) {
  return request({
    baseURL: BASE_URL + "application/editAppConfig",
    method: "post",
    data,
  });
}

export function searchUser(data) {
  return request({
    baseURL: BASE_URL + "api/staff/user/searchUserByName",
    method: "post",
    data,
  });
}

export function freezeApp(data) {
  return request({
    baseURL: BASE_URL + "application/freezeApp",
    method: "post",
    data,
  });
}

export function setAdmin(data) {
  return request({
    baseURL: BASE_URL + "application/setAdmin",
    method: "post",
    data,
  });
}

export function openApp(data) {
  return request({
    baseURL: BASE_URL + "api/staff/user/openApp",
    method: "post",
    data,
  });
}

export const tadpUserLogin = (data) => {
  return request({
    baseURL:
      BASE_URL + `tapd/userlogin?${new URLSearchParams(data).toString()}`,
    method: "get",
  });
};

// 获取验证码
export const getVerificationCode = (data) => {
  return request({
    baseURL: BASE_URL + "user/verifycode",
    method: "post",
    data,
  });
};

// 忘记密码修改
export const modifyForgetPassword = (data) => {
  return request({
    baseURL: BASE_URL + "user/ldappassword/modify",
    method: "post",
    data,
  });
};
